import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/general/user.service';
import { forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SplitIoService } from 'src/app/services/external-tools/split-io.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';

@Component({
  selector: 'app-login-callback',
  templateUrl: './login-callback.component.html',
  styleUrls: ['./login-callback.component.scss'],
  standalone: false
})
export class LoginCallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private splitService: SplitIoService,
    private logger: LoggerService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParams) => {
      const user_uuid = queryParams['user_uuid'];

      localStorage.setItem('user_uuid', user_uuid);

      if (user_uuid) {
        // Set user context in Sentry
        this.logger.setUser(user_uuid);

        // Set the userUuid in Amplitude (using service to handle localhost)
        this.amplitudeService.setUserId(user_uuid);

        // Destroy the pre-auth Split client and reinitialize with the authenticated user UUID
        this.splitService.initSplitUser(user_uuid);
      }

      // TODO: Uncomment this code to do the real request to backend to get user auth data
      forkJoin({
        authMetadata: this.userService.getAuthMetadata(),
        teamsRelationshipsForCurrentUser:
          this.userService.getTeamRelationshipsForCurrentUser(),
        authMetadataForAllAccounts:
          this.userService.getAuthMetadataForAllAccounts(),
      }).subscribe({
        next: ({ authMetadata, teamsRelationshipsForCurrentUser, authMetadataForAllAccounts }) => {
          this.userService.updateUserRoles(authMetadata.currentRoles);
          localStorage.setItem('user_first_name', authMetadata.userNameFirst);
          localStorage.setItem('user_last_name', authMetadata.userNameLast);
          localStorage.setItem(
            'current_account_uuid',
            authMetadata.currentAccountUuid
          );
          localStorage.setItem(
            'user_gender',
            authMetadata?.userGender ? authMetadata.userGender.toLocaleLowerCase() : null
          );
          console.log('user_gender: ', authMetadata?.userGender);
          localStorage.setItem(
            'accounts',
            JSON.stringify(authMetadataForAllAccounts)
          );

          localStorage.setItem(
            'relationshipsInTeams',
            JSON.stringify(teamsRelationshipsForCurrentUser)
          );

          // Update attributes for Split.io
          this.splitService.setAttributes();
        },
        error: (error) => {
          // Log the error to console and Sentry
          this.logger.error('Failed to fetch user auth metadata', error);

          this.router.navigate(['/']);
        },
        complete: () => {
          const storedUrl = localStorage.getItem('returnUrl');
          const returnUrl = storedUrl ? decodeURIComponent(storedUrl) : '/';
          console.log('returnUrl: ', returnUrl);
          if (returnUrl.includes(`${environment.adminPortal}`)) {
            window.location.assign(this.userService.getAdminPortalUrl());
          } else {
            this.router.navigateByUrl(returnUrl);
          }
        },
      });

    });
  }
}
